const mutations = {
  // Vertical NavMenu
  TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE(state, value) {
    state.isVerticalNavMenuActive = value;
  },
  TOGGLE_REDUCE_BUTTON(state, val) {
    state.reduceButton = val;
  },
  UPDATE_MAIN_LAYOUT_TYPE(state, val) {
    state.mainLayoutType = val;
  },
  UPDATE_VERTICAL_NAV_MENU_ITEMS_MIN(state, val) {
    state.verticalNavMenuItemsMin = val;
  },
  UPDATE_VERTICAL_NAV_MENU_WIDTH(state, width) {
    state.verticalNavMenuWidth = width;
  },

  // UI
  UPDATE_PRIMARY_COLOR(state, val) {
    state.themePrimaryColor = val;
  },
  UPDATE_THEME(state, val) {
    state.theme = val;
  },
  UPDATE_WINDOW_WIDTH(state, width) {
    state.windowWidth = width;
  },
  UPDATE_WINDOW_SCROLL_Y(state, val) {
    state.scrollY = val;
  },
  UPDATE_USERS_FIREBASE_STORE(state, val) {
    state.usersFirebaseStore = val;
  },
  UPDATE_MESSAGES_FIREBASE_STORE(state, val) {
    state.messagesFirebaseStore = val;
  },

  // User/Account: updates user info in state and localStorage
  UPDATE_USER_INFO(state, payload) {
    const userInfo =
      JSON.parse(localStorage.getItem("userInfo")) || state.AppActiveUser;

    for (const property of Object.keys(payload)) {
      if (payload[property] !== null) {
        // A null property keeps the default defined in state.AppActiveUser
        state.AppActiveUser[property] = payload[property];
        userInfo[property] = payload[property];
      }
    }
    localStorage.setItem("userInfo", JSON.stringify(userInfo));
  },
};

export default mutations;
